import React from 'react';
import styled from 'styled-components';

import { FieldWrapper } from '@ad-scripts/presentation/components/common/input_field';
import { H2 } from '@ad-scripts/presentation/components/common/headers';
import InputField from 'src/presentation/components/forms/InputField';
import { Section } from 'src/presentation/components/forms/Form';
import { SectionDescription } from 'src/presentation/components/forms/Layout';
import ThreadAuthenticationEmail from 'src/images/ThreadAuthenticationEmail.svg';
import ThreadCustomerIdentity from 'src/images/ThreadCustomerIdentity.svg';
import ThreadInCardMessages from 'src/images/ThreadInCardMessages.png';
import ThreadOrderStatus from 'src/images/ThreadOrderStatus.svg';
import ThreadResolution from 'src/images/ThreadResolution.svg';

export const FirstColumn = styled.div`
  padding: 0 80px;
`;
export const SecondColumn = styled.div`
  position: relative;
`;

export const ThreadCustomerIdentityImage = styled.img.attrs({ src: ThreadCustomerIdentity })`
  position: absolute;
  top: -90px;
  max-width: 520px;
`;

export const ThreadAuthenticationEmailImage = styled.img.attrs({ src: ThreadAuthenticationEmail })`
  position: absolute;
  top: 120px;
  left: 64px;
`;

export const ThreadOrderStatusImage = styled.img.attrs({ src: ThreadOrderStatus })`
  position: absolute;
  top: -70px;
  left: 32px;
  height: auto;
  width: 520px;
`;

export const ThreadInCardMessagesImage = styled.img.attrs({ src: ThreadInCardMessages })`
  position: absolute;
  top: 560px;
  left: 82px;
  height: auto;
  width: 450px;
`;

export const ThreadResolutionImage = styled.img.attrs({ src: ThreadResolution })`
  position: absolute;
  top: 1520px;
  left: 32px;
`;

export const StyledInputField = styled(InputField)`
  ${FieldWrapper} {
    width: 50%;
  }
`;

export const ThreadSection = ({ header, description, children }: { header?; description?; children }) => {
  const isHeaderVisible = header || description;
  return (
    <Section>
      {isHeaderVisible && (
        <SectionHeader>
          {header && <StyledH2>{header}</StyledH2>}
          {description && <SectionDescription>{description}</SectionDescription>}
        </SectionHeader>
      )}
      {children}
    </Section>
  );
};

const StyledH2 = styled(H2)`
  margin-bottom: 8px;
`;

const SectionHeader = styled.div`
  margin-bottom: 24px;
`;
